import { useState } from "react";
import { useFetch } from "@/lib/useFetch";
import { Spinner } from "@/app/ui";
import { fmtDate } from "@/lib/format";

const SC = {
  draft: "bg-slate-100 text-slate-600", sent: "bg-blue-50 text-blue-700",
  paid: "bg-emerald-50 text-emerald-700", overdue: "bg-red-50 text-red-700",
};

export default function AdminInvoices() {
  const { data, loading } = useFetch("/admin/invoices");
  const [q, setQ] = useState("");
  const [sf, setSf] = useState("");
  const cur = data?.currency || "€";
  const items = (data?.items || []).filter((i) =>
    (!sf || i.status === sf) &&
    (!q || (i.number || "").toLowerCase().includes(q.toLowerCase()) ||
      (i.customer_name || "").toLowerCase().includes(q.toLowerCase()) ||
      (i.business_name || "").toLowerCase().includes(q.toLowerCase())));
  if (loading) return <div className="py-10"><Spinner /></div>;
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search number, client, business…" data-testid="admin-invoice-search" className="flex-1 min-w-[200px] rounded-lg border border-slate-300 px-3 py-2 text-sm" />
        <select value={sf} onChange={(e) => setSf(e.target.value)} data-testid="admin-invoice-status-filter" className="rounded-lg border border-slate-300 px-3 py-2 text-sm bg-white">
          <option value="">All statuses</option>
          {["draft", "sent", "paid", "overdue"].map((s) => <option key={s} value={s} className="capitalize">{s}</option>)}
        </select>
      </div>
      <div className="amden-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-left"><tr>
            <th className="px-4 py-3 font-semibold">Invoice</th><th className="px-4 py-3 font-semibold">Business</th>
            <th className="px-4 py-3 font-semibold hidden sm:table-cell">Client</th><th className="px-4 py-3 font-semibold text-right">Total</th>
            <th className="px-4 py-3 font-semibold text-right hidden md:table-cell">Balance</th><th className="px-4 py-3 font-semibold">Status</th>
            <th className="px-4 py-3 font-semibold text-right">Date</th></tr></thead>
          <tbody>
            {items.map((i) => (
              <tr key={i.id} className="border-t border-slate-100" data-testid={`admin-invoice-${i.id}`}>
                <td className="px-4 py-3 font-medium text-navy">{i.number}</td>
                <td className="px-4 py-3 text-slate-600">{i.business_name || "—"}</td>
                <td className="px-4 py-3 text-slate-600 hidden sm:table-cell">{i.customer_name}</td>
                <td className="px-4 py-3 text-right font-mono">{cur}{i.total}</td>
                <td className="px-4 py-3 text-right font-mono hidden md:table-cell">{cur}{i.balance}</td>
                <td className="px-4 py-3"><span className={`text-xs px-2 py-0.5 rounded-full capitalize ${SC[i.status] || "bg-slate-100 text-slate-600"}`}>{i.status}</span></td>
                <td className="px-4 py-3 text-right text-slate-500">{fmtDate(i.issue_date || i.created_at)}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-slate-400">No invoices.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
